import { VolatilityHeatmapProvider } from '../../../../providers/widgets/volatility-heatmap/volatility-heatmap-provider';
import VolatilityHeatmapWidget from './volatility-heatmap-widget';
import { IVolatilityHeatmapWidgetProps } from './types';

const VolatilityHeatmapWrapperProvider = (props: IVolatilityHeatmapWidgetProps) => {
  return (
    <VolatilityHeatmapProvider providerKey={props.providerKey}>
      <VolatilityHeatmapWidget {...props} />
    </VolatilityHeatmapProvider>
  );
};

export default VolatilityHeatmapWrapperProvider;
